<template>
  <div id="com">
    <div class="title">
      <h2>陕西省住建厅综合服务中心</h2>
    </div>
    <div class="query-bt">
      建设工程质量检测机构资质证书
    </div>
    <div class="query-scan-box">
      <div class="query-scan">
      <i class="iconfont icon-duigou"></i>
      <span>证书是否有效：有效</span>
    </div>
    <div class="query-context">
      <ul>
        <li>
          <span  class="context-bt">证书编号：</span>
          <span  class="context-nr">陕建检字第397号</span>
        </li>
        <li class="context-bj">
          <span  class="context-bt">机构名称：</span>
          <span  class="context-nr">陕西同圆工程检测有限公司</span>
        </li>
        <li class="li-im">
          <div  class="context-bt context-btt" >检测范围：</div>
          <div  class="context-nr context-nrr" >见证取样类 房屋建筑土建工程建筑材料、构配件进场见证取样检测 水泥物理力学性能检验,钢筋（含焊接与机械连接）力学性能检验,砂、石常规检验,混凝土、砂浆强度检验,简易土工试验,混凝土掺加剂检验,防水材料及抗渗混凝土检验验~专项检测类 主体结构工程检测 混凝土、砂浆、砌体强度现场检测,钢筋保护层厚度检测,后置埋件的力学性能检测。~专项检测类 钢结构工程检测 钢结构焊接质量无损检测,钢结构防腐及防火涂装检测,钢结构节点、机械连接用紧固标准件及高强度螺栓力学性能检测,钢网架结构的变形检测。</div>
        </li>
        <li class="context-bj">
          <span  class="context-yxq">有效期：</span>
          <span  class="context-nr">2025-06-30</span>
        </li>
        <li>
          <span  class="context-bt">发证机关：</span>
          <span  class="context-nr">陕西省住房和城乡建设厅</span>
        </li>
        <li class="context-bj">
          <span  class="context-bt">发证日期：</span>
          <span  class="context-nr">2023-03-24</span>
        </li>
      </ul>
    </div>
    <div class="query-zzzs">
      <img src="../img/zzzs.png" alt="">
    </div>
    </div>
    
  
  </div>
</template>


<script>
import '../style/fonts/iconfont.css'
   export default {
    name: 'queryResults',
    data() {
      return {
        loading: true,
        labelPosition: 'right',
        report:''

      };
    },
    created(){
      document.title = "查询结果-证照通";
      //this.$root.Bus.$emit('toggle', this.collapsed)
      //console.log($route.name);

    },
    methods: {

    },
    mounted(){

      
		}


  }
    </script>

    <!-- Add "scoped" attribute to limit CSS to this component only -->
    <style scoped>
       /* html{
        font-size: calc(100vw / 10);
       } */
      /* #com{
        width: 7.5rem;
        font-size: 0.14rem;
      } */
       * {
    margin: 0rem;
    padding: 0rem;
}
#com {
  width: 10rem;
  background-color: #f7f7f7;
  border: 1px solid #ccc;
}
.title {
  height: 1.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  background: url(../img/header-left.png) no-repeat 0, url(../img/header-right.png) no-repeat 100%, #3a97fc;
  color: #fff;
  font-size: 12px;
}
.query-bt {
  text-align: center;
  font-weight: 500;
    color: #17233d;
    font-size: 16px;
    margin: 16px 0;
}
.query-scan-box {
  width:100%;
}
.query-scan{
  width: 8.6rem;
  position: relative;
  margin: 0.4rem auto;
  border: 1px solid #8ce6b0;
    background-color: #edfff3;
    padding-left: 0.4rem;
    height: 0.8rem;
} 
.query-scan-box i {
  line-height: 0.8rem;
}
.query-scan-box span {
  color: #515a6e;
    font-size: 14px;
    line-height: 0.8rem;
    padding-left: 0.1rem;
}
.query-scan-box i {
  width:1rem !important;
}
.query-context {
  height: 12rem;
}
.query-context .context-bt {
  padding: 0.1rem 0 0.1rem 1.3rem;
  font-size: 14px;
  color: #515a6e;
  font-weight: 600;
}
.query-context .context-nr {
  font-size: 14px;
  color: #515a6e;
}
.query-context .context-bj {
  width: 8.6rem;
  position: relative;
  margin: 0 auto;
  list-style-type: none;
    padding-left: 0.4rem;
    
  background-color: #eee;
}
.query-context .context-bj .context-bt {
  padding-left: 0.4rem !important;
}
li {
  height: 0.8rem;
  line-height: 0.7rem;
}
.li-im {
  height: 3.2rem !important;
}

.query-context .context-btt {
  float: left;
  width: 2rem;
  height: 2.4rem;
}
.query-context .context-yxq {
  padding: 0.1rem 0 0.1rem 1.3rem;
  font-size: 14px;
  color: #515a6e;
  font-weight: 600;
  padding-left: 0.7rem !important;
}
.query-context .context-nrr {
  padding-top: 0.1rem;
  float: left;
  width: 6rem;
  height: 2.4rem;
  line-height: 0.51rem;
}
.query-zzzs {
  width: 9rem;
  margin: 0 auto;
}
.query-zzzs img {
  width: 9rem;
  
}

    </style>



// WEBPACK FOOTER //
// src/views/report/QueryResults.vue